const TIMINGS = {
  fast: "200",
  medium: "300",
  slow: "400",
}

const ANIMATION = {
  effect: "fades",
  ease: "ease",
  duration: "1500",
}

export { TIMINGS, ANIMATION }
